import React, { useState, useRef } from 'react';

import './UserPhotoPopup.scss';
import setUserPhoto from '@helpers/setUserPhoto';
import { clearUrlQuery } from '@helpers/misc';
import UserPhoto from '../../shared/assets/icons/userPhoto.svg';

export default function UserPhotoPopup(props) {
  const uploadButton = useRef(null);

  const [isHide, setIsHide] = useState(false);
  const [userPhoto, updateUserPhoto] = useState(null);
  const [validationError, setValidationError] = useState(null);

  return isHide ? null : (
    <section className="userPhotoPopup">
      <form>
        <p className="userPhotoPopup_title">
          Wacht even... upload snel je profiel foto...
        </p>

        <div
          className="userPhotoPopup_photo"
          onClick={() => uploadButton.current.click()}
        >
          {userPhoto ? <img src={userPhoto} alt="user-image" /> : <UserPhoto />}
        </div>

        <label
          htmlFor="userPhotoPopup_photo"
          className="userPhotoPopup_upload_photo_label"
          onClick={() => uploadButton.current.click()}
        >
          Kies een profielfoto
        </label>

        <input
          hidden
          type="file"
          accept="image/*"
          ref={uploadButton}
          onChange={(e) => setPhoto(e)}
        />

        {validationError && (
          <div className="userPhotoPopup_error">{validationError}</div>
        )}

        <input
          type="submit"
          value="Afbeelding uploaden"
          onClick={(e) => uploadPhoto(e)}
          className="userPhotoPopup_button"
        />

        <p className="userPhotoPopup_skip_label" onClick={() => hidePopup()}>
          Overslaan
        </p>
      </form>
    </section>
  );

  function setPhoto(e) {
    if (e.target.files && e.target.files[0]) {
      setUserPhoto({
        updateUserPhoto,
        file: e.target.files[0],
        setUserPhotoMutation: props.setUserPhoto
      });

      setValidationError(null);
    }
  }

  function uploadPhoto(e) {
    e.preventDefault();

    if (!userPhoto) setValidationError('Upload een foto alsjeblieft');
    else
      props.addUserEventAndRedirect({
        variables: { type: 'popup-close:user-photo', data: '{}' }
      });
  }

  function hidePopup() {
    setIsHide(true);
    clearUrlQuery();
    props
      .addUserEvent({
        variables: { type: 'popup-close:user-photo', data: '{}' }
      })
      .then(() => props.metaRefetch());
  }
}
